const mutations = {
  setUser(state, data) {
    state.userEdit = data
  },
  setUserMap(state, data) {
    state.userMap = data
  }
}

export default mutations